import {fromJS, Map} from 'immutable';
import myTopPerformingGamesActions from '../../actions/fortnite-game/myTopPerformingGames.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {DataItem} from './types';
import {MyTopPerformingGame} from '../../types';

export interface MyTopPerformingGamesDataItem extends Omit<DataItem, 'amount'> {
    value: string;
    label?: string;
    creativeIslandCode?: string;
}

export interface MyTopPerformingGamesState {
    [MyTopPerformingGame.MOST_POPULAR_GAME]: MyTopPerformingGamesDataItem;
    [MyTopPerformingGame.HIGHEST_GROWTH]: MyTopPerformingGamesDataItem;
    [MyTopPerformingGame.HIGHEST_AVG_PLAY_TIME]: MyTopPerformingGamesDataItem;
    [MyTopPerformingGame.MOST_VISITED_GAME]: MyTopPerformingGamesDataItem;
}

export const DEFAULT_DATA = {
    mostPopularGame: {
        value: '',
        trend: 0,
        loading: true
    },
    highestGrowth: {
        value: '',
        trend: 0,
        loading: true
    },
    highestAvgPlayTime: {
        value: '',
        trend: 0,
        loading: true
    },
    mostVisitedGame: {
        value: '',
        trend: 0,
        loading: true
    }
};

export const DEFAULT_STATE = fromJS({
    ...DEFAULT_DATA
});

export const myTopPerformingGamesReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {data, error, value} = action.payload || {};

    switch (action.type) {
        case myTopPerformingGamesActions.TYPES.GET_TOP_PERFORMING_GAMES: {
            return state.merge({
                [value]: state.get(value).merge({
                    error: undefined,
                    loading: true
                })
            });
        }

        case myTopPerformingGamesActions.TYPES.GET_TOP_PERFORMING_GAMES_COMPLETE: {
            return state.merge({
                [value]: state.get(value).merge({
                    ...data,
                    loading: false
                })
            });
        }

        case myTopPerformingGamesActions.TYPES.GET_TOP_PERFORMING_GAMES_FAILED: {
            return state.merge({
                [value]: state.get(value).merge({
                    error,
                    loading: false
                })
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('myTopPerformingGames', myTopPerformingGamesReducer);
